import { v4 as uuidv4 } from 'uuid';

export function requestKeyHeaderKyHook(request: Request) {
  const requestKey = uuidv4();
  request.headers.set('x-browser-request-id', requestKey);
}
